import { AppDispatch } from '../store'
import overviewActionTypes from '../actionTypes/overview.actionTypes'
import {
    OverviewWidgetResponse_FieldGroup,
    OverviewWidgetResponse_IndexComponent,
    PerformancePeriod
} from '../proto/generated/overview-widget'
import { CommunityScreenMetadata } from '../proto/generated/screener'

const dispatchOverviewData = (
    dispatch: AppDispatch,
    securityKey: string,
    fieldGroups: OverviewWidgetResponse_FieldGroup[],
    indexComponents: OverviewWidgetResponse_IndexComponent[],
    performance: PerformancePeriod[],
    communityScreens: CommunityScreenMetadata[],
    indexComponentTotalCount = 0,
    hasIndexContribution = false,
) => {
    dispatch({
        type: overviewActionTypes.SET_OVERVIEW_DATA,
        payload: {
            securityKey,
            fieldGroups,
            indexComponents,
            performance,
            communityScreens,
            indexComponentTotalCount,
            hasIndexContribution,
        }
    })
}

const clearOverview = (dispatch: AppDispatch) => {
    dispatch({ type: overviewActionTypes.CLEAR_OVERVIEW })
}

const overviewActions = {
    dispatchOverviewData,
    clearOverview
}

export default overviewActions
